<template>
  <div>
    <div class="tek">
      <div class="profilePicture" style="opacity: 0"></div>
      <span class="label small">Naam</span>
      <span class="label small">Disciplines</span>
      <span class="label medium">Tekenprogramma</span>
      <span class="label extra-small">Uren</span>
      <span class="label small">Berekeningen</span>
      <span class="label medium">NEN-2580</span>
      <span class="label medium">Werkgebied/Woonplaats</span>
      <span class="label small">Telefoon</span>
    </div>
    <div class="tek searchBar">
      <div class="profilePicture" style="opacity: 0"></div>
      <input class="label small" placeholder="Zoek..." v-model="filters.name" />
      <select class="label small" v-model="filters.disciplines">
        <option value="">Selecteer</option>
        <option :value="d" :key="i" v-for="(d, i) in disciplines">{{ d }}</option>
      </select>
      <select class="label medium" v-model="filters.tekenprogramma">
        <option value="">Selecteer</option>
        <option :value="t" :key="i" v-for="(t, i) in tekenprogrammas">{{ t }}</option>
      </select>
      <input style="opacity: 0; pointer-events: none;" class="label extra-small" placeholder="Zoek..." v-model="filters.beschikbaarheid" />
      <select class="label small" v-model="filters.berekeningen">
        <option value="">Selecteer</option>
        <option :value="w" :key="i" v-for="(w, i) in berekeningen">{{ w }}</option>
      </select>
      <select class="label medium" v-model="filters.nen2580">
        <option value="">Selecteer</option>
        <option :value="w" :key="i" v-for="(w, i) in nen2580">{{ w }}</option>
      </select>
      <select class="label medium" v-model="filters.werkgebied">
        <option value="">Selecteer Werkgebied</option>
        <option :value="w" :key="i" v-for="(w, i) in werkgebied">{{ w }}</option>
      </select>
      <input class="label small" placeholder="Zoek..." v-model="filters.telefoonnummer" />
    </div>
  </div>
</template>

<script>
import { computed, ref, watch, watchEffect } from "@vue/runtime-core"
import { useStore } from "vuex"

export default {
  setup() {
    const tekenprogrammas = ["autocad", "revit", "solidworks", "bricscad", "inventor", "solid edige", "vectorworks", "rhinoceros", "microstation", "onshape", "sketch-up", "arkey", "tekla"]
    const werkgebied = ["drenthe", "flevoland", "friesland", "gelderland", "groningen", "limburg", "overijssel", "utrecht", "zeeland", "zuid-holland", "noord-brabant", "noord-holland"]
    const berekeningen = ["constructieberekening", "krachtenberekening"]
    const nen2580 = ["nen2580 inmeten", "nen2580 rapportage opstellen", "nen2580 plattegrond opstellen"]
    const store = useStore()
    const disciplines = computed(() => store.state.disciplines_lowercase)

    const filtersInStore = computed(() => store.state.tekFilters)

    const filters = ref({})

    watchEffect(() => {
      filters.value = filtersInStore.value
    })

    watch(filters, (newValue, oldValue) => {
      console.log(newValue, oldValue)
    })

    // const updateFilters = () => {}

    return {
      store,

      tekenprogrammas,
      werkgebied,
      berekeningen,
      nen2580,
      disciplines,
      filters
    }
  }
}
</script>

<style lang="sass" scoped>

.tek
  margin: 0 auto
  display: flex
  width: fit-content
  align-items: center
  background-color: #e4ecfa
  border: 1px solid rgba(0, 0, 0, 0.05)
  border-bottom: none
  color: black
  font-weight: 500
  padding: 0.5em 14px 0em
  width: 100%
  overflow-x: hidden

  &.searchBar
    border-top: none
    padding: 0 1em 0.3em
    input, select
      transform: translateX(-6px)
      background-color: rgba(0, 0, 0, 0)
      border: 1px solid rgba(0,0,0,0.0)
      border-radius: 0.5em
      padding: 0.5em
      padding-left: 0
      opacity: 0.5
      &:hover
        background-color: rgba(255, 255, 255, 0.5)
    input
      transform: translateX(-2px)


  > *
    white-space: nowrap
    margin-right: 15px
    min-width: 180px
    // width: 10%

  .label
    overflow-x: hidden
    &.extra-small
      $size: 70px
      min-width: $size
      max-width: $size
    &.small
      $size: 150px
      min-width: $size
      max-width: $size
    &.medium
      $size: 220px
      min-width: $size
      max-width: $size
    &.large
      $size: 240px
      min-width: $size
      max-width: $size



span
  white-space: nowrap
  overflow-x: hidden
  font-size: 15px

.profilePicture
  $size: 32px
  min-width: $size
  max-width: $size
  min-height: $size
  max-height: $size
  border-radius: 100%
  background-color: rgba(0, 0, 0, 0.05)
  background-size: cover
  background-position: center
</style>
